import { ChargePointHasLocation } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/charge-point/charge-point-has-location.enum';
import { useTranslation } from 'react-i18next';

import { BooleanTriStateFilterController } from '@shared/filter/boolean-tri-state-filter/boolean-tri-state-filter.controller';

interface ChargePointHasLocationFilterControllerProps {
  // null (not undefined) represents "All" — react-hook-form's Controller
  // falls back to its mount-time default whenever the live value is
  // undefined, so an explicit clear must never be undefined.
  onChange: (value: boolean | null) => void;
  selectedItem?: boolean | null;
}

const backgroundColorByState: Record<ChargePointHasLocation, string> = {
  [ChargePointHasLocation.TRUE]: 'bg-surface-success',
  [ChargePointHasLocation.FALSE]: 'bg-surface-error',
  [ChargePointHasLocation.ALL]: 'bg-surface-brand-secondary',
};

export const ChargePointHasLocationFilterController = ({
  onChange,
  selectedItem,
}: ChargePointHasLocationFilterControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // DATA FETCHING /////////////////////////////////////////////////////////////

  const options = Object.values(ChargePointHasLocation).map((state) => ({
    key: state,
    label: t(
      `delmonicos-shared-sdk.outputs-charge-point-has-location.${state}`,
    ),
    value:
      state === ChargePointHasLocation.TRUE
        ? true
        : state === ChargePointHasLocation.FALSE
          ? false
          : null,
    colorClassName: backgroundColorByState[state],
  }));

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <BooleanTriStateFilterController
      iconName="location"
      text={t('delmonicos-shared-sdk.outputs-charge-point.has-location')}
      options={options}
      selectedItem={selectedItem}
      onChange={onChange}
    />
  );
};
